import React from 'react'

import ScrollToTop from "react-scroll-to-top";
import "./Home.css";

import law from "../images/LAW.jpg";
import english from "../images/english speek.jpg";
import Corporate from "../images/corporate.jpg";

import Quote from './Quote';
import ReactWhatsapp from "react-whatsapp";
import Header from '../inc/Header';
import CornChessyBite from "../images/Corn Chessy Bite.jpeg";
import icecream from "../images/ice cream.jpg";
import Ourstore from './Ourstore';
import EventGallery from './EventGallery';
import Product from './Product';
import Youtubevideo from './Youtubevideo';

import bestphoto from "../images/best photo.jpg";
import products from "../images/products.jpg";
import enjoythesummer from "../images/summer.jpeg";

import hotcoffee from "../images/hot coffee.jpeg"
import SliderHome from '../inc/SliderHome';
import NewProducts from './NewProducts';
import ButtomBar from "./ButtomBar";
import Popup from "./Popup";

import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import cafe_krishnagar from "../images/Video 5sec.mp4";
import shopvideo from "../images/Video shop.mp4";
import SlideEnquiryButton from './SlideEnquiryButton';
import StatsBar from './StatsBar';
import Summer from './Summer';


function Home() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />

      <div className="album py-2">
        <div className="container">
          <h5>The Love Bird's Icecream</h5>
        </div>
      </div>

      <SliderHome />

      <ScrollToTop smooth top="100" color="grey" style={{margin:"10px"}}/>

      <div className='colorbackmarquee'>
        <div className="album py-0">
          <div className="container">
            <marquee > <h5 style={{ color: "white" }} className='mt-3'>Welcome to The Love Bird's Icecream Parlour | India's No1 Icecream Brand  </h5></marquee>
          </div>
        </div>
      </div>
      <br/>
      <StatsBar/>
       <center>
  <br/>
 <>
      <a
        href="https://share.google/PZTAAWqpJFnGKeNjV"
        target="_blank"
        rel="noopener noreferrer"
        className="google-btn"
      >
        <span className="google-text">
          <span className="g-blue">G</span>
          <span className="g-red">o</span>
          <span className="g-yellow">o</span>
          <span className="g-blue">g</span>
          <span className="g-green">l</span>
          <span className="g-red">e</span>
        </span>

        <span className="stars">★★★★★</span>

        <span className="review-text">66 Google reviews</span>
      </a>

      <style>{`
        .google-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 12px 20px;
          border-radius: 40px;
          background: #fbf8f8;
          text-decoration: none;
          border: 1px solid #ecebea;
          font-family: Arial, sans-serif;
          transition: 0.3s;
        }

        .google-btn:hover {
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .google-text {
          font-size: 20px;
          font-weight: 600;
        }

        /* Google Colors */
        .g-blue { color: #4285F4; }
        .g-red { color: #EA4335; }
        .g-yellow { color: #FBBC05; }
        .g-green { color: #34A853; }

        .stars {
          color: #fbbc05;
          font-size: 18px;
          letter-spacing: 2px;
        }

        .review-text {
          color: #333;
          font-size: 16px;
          text-decoration: underline;
        }

        /* Mobile Responsive */
        @media (max-width: 600px) {
          .google-btn {
            padding: 8px 10px;
            gap: 6px;
          }

          .google-text {
            font-size: 16px;
          }

          .stars {
            font-size: 14px;
          }

          .review-text {
            font-size: 14px;
          }
        }
      `}</style>
    </>
    </center>
  <br/>
  <ButtomBar/>
       <div className='sumerfoodkrishnagar'>
<br />
<div className="album py-0">
          <div className="container">
            <h1 className='summer'><b>Summer Special</b></h1>
          </div>
        </div>
          <Summer/>
        </div>
 
  
      <div className='winterfoodkrishnagar'>
<br />
        <div className="album py-0">
          <div className="container">
            <h1 className='winter'><b>Winter Special</b></h1>
          </div>
        </div>
        <NewProducts />
      </div>
<SlideEnquiryButton/>

      <div className="album py-1">
        <div className="container">
          <h1 className='mt-2'><b>Social Media - Facebook <a href='https://www.facebook.com/da.labha.bardasa' target="_blank" rel="noopener noreferrer">Follow</a></b></h1>
</div>
</div>
      <div className="album py-1">
        <div className="container">

          <div className="row">
            <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fda.labha.bardasa%2F&tabs=timeline&width=1000&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="700"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
              </div>
   <div className="col-md-6 mt-3">
              <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2272505666511658%2F&show_text=true&width=267&t=0" width="100%" height="700"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
              </div>
              </div>
              </div>
              
            </div>

 <div className="album py-1">
        <div className="container">
          <div className="row ">
      
            <div className="col-md-6 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={cafe_krishnagar} type="video/webm" />
              </Video>
            </div>
            <div className="col-md-6 mt-2">

              <Video Play muted loop onCanPlayThrough={() => {
                console.log('video play')
              }}>
                <source src={shopvideo} type="video/webm" />
              </Video>
            </div>
         

          </div>
        </div>
      </div>
      {/* <ReactWhatsapp number="+91 9932517802" className="btn btn-success" message="I am Interested"> Whatsapp Contact</ReactWhatsapp> */}
<Popup/>
      <div className="album py-1">
        <div className="container">

          <div className="row">
            <div className="col-md-4 mt-3">
              <div className="card text-dark bg-light mb-3" >
                <div className='btn-grad41 blink mb-2'>IMPORTANT LINK</div>
                <div className="card-body">
                  <a href='/apply-franchisee'>
                    <div className='btn-grad42 mb-2'>Apply for Franchisee </div>
                  </a>
                  <a href='products'>
                    <div className='btn-grad42 mb-2'>All Products </div></a>

                  <a href='Careerpage'>
                    <div className='btn-grad42 mb-2'> Career </div>
                  </a>
                </div>
              </div>
            </div>


            <div className="col-md-2 mt-3">
              <div className="card">
                <img src={enjoythesummer} className="card-img-top mb-0" alt="enjoythesummer" />

                <div className="card-body">
                  <center>
                    <h5 className="card-title mb-0">Enjoy The Summer</h5>
                    <p className="card-text mb-1">Icecream Strating @15/-</p>
                    <a href="tel: 7031820115" className="ordernow">Order Now</a>
                  </center>
                </div>


              </div>
            </div>


            <div className="col-md-2 mt-3">
              <div className="card">
                <img src={hotcoffee} className="card-img-top mb-0" alt="hotcoffee" />

                <div className="card-body">
                  <center>
                    <h5 className="card-title mb-0">Special Hot Coffee</h5>
                    <p className="card-text mb-1">Taste Now</p>
                    <a href="tel: 7031820115" className="ordernow">Order Now</a>
                  </center>
                </div>


              </div>
            </div>

            <div className="col-md-2 mt-3">
              <div className="card">
                <img src={CornChessyBite} className="card-img-top mb-0" alt="CornChessyBite" />

                <div className="card-body">
                  <center>
                    <h5 className="card-title mb-0">Corn Chessy Bite</h5>
                    <p className="card-text mb-1">Best quality products</p>
                    <a href="tel: 7031820115" className="ordernow">Order Now</a>
                  </center>
                </div>


              </div>
            </div>
            <div className="col-md-2 mt-3">
              <div className="card">
                <img src={icecream} className="card-img-top mb-0" alt="icecream" />

                <div className="card-body">
                  <center>
                    <h5 className="card-title mb-0">Ice Cream</h5>
                    <p className="card-text mb-1">Best quality products</p>
                    <a href="tel: 7031820115" className="ordernow">Order Now</a>
                  </center>
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
      <br />
      <div className='backcoloryellow'>
        <br />
        <Ourstore />
        <br />
      </div>
      <br />
      <div className="album py-1">
        <div className="container">
          <center>
            <div className='colorchaclate'>
              <h1 className='mt-1 mb-4'><b>PRODUCTS</b></h1>
            </div>
          </center>
        </div>
      </div>
      <Product />
      <Youtubevideo />
      <div className="album py-1">
        <div className="container">
          <center>
            <div className='colorchaclate'>
              <h1 className='mt-1 mb-4'><b>GALLERY & EVENT</b></h1>
            </div>
          </center>
        </div>
      </div>
      <EventGallery />
      <br />


   
      <br />
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">


              <div className='borderradios'>
                <img src={bestphoto} className="card-img-top" alt="bestphoto" />
              </div>


            </div>
            <div className="col-md-6 mt-3">

              <div className='borderradios'>
                <img src={products} className="card-img-top" alt="products" />
              </div>

            </div>
          </div>
        </div>
      </div>
      <br />


    </div>
  )
}

export default Home